import React , { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { storageAvailable } from 'lib/utils'
import _ from 'lib/lodash'

import { dispatchActions as dispatchStickerActions } from 'components/sticker/stickerHandlerRedux'
import { actions as toastActions } from 'components/handlers/notification/notificationHandlerRedux'

import LoadingSpinner from 'components/common/LoadingSpinner'

class StickerHandler extends Component {
	state = {
		StickerComponent: null,
		componentError: null
	};

	componentDidMount() {
		const { bundleNo, stickerId } = this.props.match.params;
		const tagId = _.get(this.props, 'location.state');

		/* make GTM variable available */
		if (!!bundleNo && storageAvailable()) window.sessionStorage.setItem('bundleNo', bundleNo);

		this.props.fetchStickerById(stickerId, tagId);
	}

	componentWillUnmount() {
		this.props.resetStickerHandler();
		this.props.signOut();
	}

	componentDidUpdate() {
		const { sticker, error } = this.props.stickerHandler;
		const { StickerComponent, componentError } = this.state;

		if (sticker && !StickerComponent && !componentError) {
			/* import component from configured path */
			const { type } = sticker;

			import(`components/profiles/${type.main}/${type.sub}/${type.version}`).then(
				StickerComponent => this.setState({ ...this.state, StickerComponent: StickerComponent.default }),
				error => {
					this.setState({ ...this.state, componentError: error });
					this.props.addErrorToast(error.message)
				}
			);
		}

		/* display error toasts */
		if (error) {
			switch (error.error) {
				case 'INVALID_STICKER_ID':
					this.props.addErrorToast(`Zu diesem Sticker liegen keine Informationen vor.`);
					break;

				default:
					break;
			}
		}
	}

	render() {
		const {isLoading, error, sticker} = this.props.stickerHandler;
		const {StickerComponent, componentError} = this.state;

		if (error || componentError) return <Redirect to={'/home'}/>;
		if (isLoading) return <LoadingSpinner message={`Sticker wird geladen...`}/>;

		return sticker && StickerComponent && <StickerComponent/>;
	}
}

const mapStateToProps = ({ tagHandler, stickerHandler }) => ({ tagHandler, stickerHandler });

export default connect(mapStateToProps, { ...dispatchStickerActions, ...toastActions })(StickerHandler);


// WEBPACK FOOTER //
// ./src/components/sticker/StickerHandler.jsx